module.exports = __webpack_public_path__ + "static/media/foto_a3.1d5bf0ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/foto_a3.jpg
// module id = 1295
// module chunks = 0